import React, { memo, useMemo } from 'react';
import { LogOut, Shield } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { AdsButton } from './ads';
import {
  buildMainContentClassName,
  buildPageContentClassName,
  resolveAdminLayoutMeta,
} from '../routing/routeLayoutMeta';
import '../styles/layout1-professional.css';
import '../styles/layouts/ads-shell.css';
import '../styles/layouts/shell-enterprise.css';

/**
 * Unified shell for platform admin — same chrome family as business Layout (P1-3).
 */
const AdminShellLayout = memo(function AdminShellLayout({ children, onLogout }) {
  const { t, isRTL } = useLanguage();
  const ta = (key) => t(`adminDashboard.${key}`);
  const layoutMeta = useMemo(() => resolveAdminLayoutMeta(), []);
  const mainContentClassName = buildMainContentClassName(layoutMeta);
  const pageContentClassName = buildPageContentClassName(layoutMeta);

  return (
    <div
      className="layout ads-shell layout--admin-shell"
      style={{ direction: isRTL ? 'rtl' : 'ltr' }}
    >
      <div className={mainContentClassName}>
        <header className="main-header" dir={isRTL ? 'rtl' : 'ltr'}>
          <div className="header-left">
            <div className="business-header-info">
              <h1 className="business-name">
                <Shield size={18} strokeWidth={1.35} aria-hidden style={{ marginInlineEnd: 8 }} />
                {ta('shellBrand')}
              </h1>
            </div>
          </div>
          <div className="header-center" />
          <div className="header-right">
            {onLogout ? (
              <AdsButton
                type="button"
                variant="secondary"
                className="admin-shell-logout"
                onClick={onLogout}
              >
                <LogOut size={16} aria-hidden />
                {ta('logout')}
              </AdsButton>
            ) : null}
          </div>
        </header>
        <main className={pageContentClassName}>
          <div className="page-view">{children}</div>
        </main>
      </div>
    </div>
  );
});

export default AdminShellLayout;
